import {createRouter, createWebHashHistory, createWebHistory, RouteRecordRaw} from 'vue-router'
import Home from '../views/Home.vue'
import newPage from '../views/newPage.vue'
import oldPage from '../views/oldPage.vue'
import About from '../views/About.vue'
import morePage from '../views/morePage.vue'
import myComment from '../views/myComment.vue'
import root from '../views/root.vue'
import homepage from '../views/homepage.vue'
import yearStudentsInfo from '../views/yearStudentsInfo.vue'
import company from '../views/company.vue'
import activity from '../views/activity.vue'
import work from '../views/work.vue'
import login from '../views/login.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/home',
    name: 'Home',
    component: () => import(/* webpackChunkName: "todo" */ '@/views/Home.vue'),
    children: [
      {
        path: 'homepage',
        name: '重点数据',
        component: () => import(/* webpackChunkName: "todo" */ '@/views/homepage.vue')
      }
      ,
      {
        path: 'newPage',
        name: 'newPage',
        component: () => import(/* webpackChunkName: "todo" */ '@/views/newPage.vue')
      },
      {
        path: 'oldPage',
        name: 'oldPage',
        component: () => import(/* webpackChunkName: "todo" */ '@/views/oldPage.vue')
      },
      {
        path: 'cooperation',
        name: 'cooperation',
        component: () => import(/* webpackChunkName: "todo" */ '@/views/cooperation.vue')
      },
      {
        path: 'morePage',
        name: 'morePage',
        component: () => import(/* webpackChunkName: "todo" */ '@/views/morePage.vue')
      },
      {
        path: 'myComment',
        name: 'myComment',
        component: () => import(/* webpackChunkName: "todo" */ '@/views/myComment')
      }
      ,

      {
        path: 'year',
        name: '分届别生源信息展示',
        component: () => import(/* webpackChunkName: "todo" */ '@/views/yearStudentsInfo.vue')
      }
      ,
      {
        path: 'company',
        name: '合作用人单位情况展示',
        component: () => import(/* webpackChunkName: "todo" */ '@/views/company.vue')
      }
      ,
      {
        path: 'activity',
        name: '招聘活动情况展示',
        component: () => import(/* webpackChunkName: "todo" */ '@/views/activity.vue')
      }
      ,
      {
        path: 'work',
        name: '就业情况展示',
        component: () => import(/* webpackChunkName: "todo" */ '@/views/work.vue')
      }
      ,
    ]
  },
    {
        path: '/login',
        name: '登录',
        component: () => import(/* webpackChunkName: "todo" */ '@/views/login.vue')
    },
    {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "todo" */ '@/views/About.vue')
  },
  {
    path: '/',
    name: 'root',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "todo" */ '@/views/root.vue')
  },

]

//   history: createWebHashHistory(process.env.BASE_URL),
//   history: createWebHistory(process.env.BASE_URL),

const router = createRouter({
  //  history: createWebHashHistory(process.env.BASE_URL),
   history: createWebHashHistory(process.env.BASE_URL),
  routes
})

export default router
